"use client";

import { useEffect } from "react";
import { stickyFooterCourseStorageKey } from "../lib/util";
import { setPageContext, trackEvent } from "../lib/engageXClient";

const StickyCourseTracker = ({ course }) => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const payload = course?.id
      ? {
          id: course?.id,
          name: course?.course_name,
          discuntPrice: course?.discounted_price,
          price: course?.price,
          productId: course?.product_id,
        }
      : null;

    if (payload) {
      localStorage.setItem(stickyFooterCourseStorageKey, JSON.stringify(payload));
    }

    return () => {
      localStorage.removeItem(stickyFooterCourseStorageKey);
    };
  }, [
    course?.id,
    course?.course_name,
    course?.discounted_price,
    course?.price,
    course?.product_id,
  ]);

  // Tracking plan: every event on this page carries the course, and the page
  // itself is one view_course.
  useEffect(() => {
    if (!course?.course_name) return;
    const category = course?.category?.name || course?.category?.slug || undefined;
    const location = /-in-[a-z-]+$/.test(window.location.pathname);
    setPageContext({ page_type: location ? "location" : "course", course_name: course.course_name, category });
    trackEvent("view_course", {
      course_name: course.course_name,
      category,
      rating: course?.course_rating || undefined,
      enrolled_count: course?.total_enrollments ? String(course.total_enrollments).replace(/\s*enrolled\s*$/i, "") : undefined,
    });
  }, [course?.course_name]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};

export default StickyCourseTracker;
